<template>
  <div class="writing-page">
    <p>english</p>
    <div class="word" v-for="(word, wordIndex) in text" :key="wordIndex">

      <span v-for="(char, charIndex) in word" :key="charIndex">
        <span v-if="wordIndex >= writtenWords.length || charIndex >= writtenWords[wordIndex].length">
          <letter v-if="wordIndex == currentWord" class="not-written">{{char}}</letter>
          <letter v-else>{{char}}</letter>
        </span>
        <span v-else-if="text[wordIndex][charIndex] === writtenWords[wordIndex][charIndex]">
          <letter v-if="wordIndex == currentWord" class="correct current-word">{{char}}</letter>
          <letter v-else class="correct">{{char}}</letter>
        </span>
        <span v-else-if="text[wordIndex][charIndex] !== writtenWords[wordIndex][charIndex]">
          <letter v-if="wordIndex == currentWord" class="incorrect current-word">{{char}}</letter>
          <letter v-else class="incorrect">{{char}}</letter>
        </span>
      </span><!--
      --><span v-for="(char, charIndex) in writtenWords[wordIndex]" :key="'A' + charIndex">
        <span v-if="charIndex >= word.length">
          <letter v-if="wordIndex == currentWord" class="incorrect current-word">{{char}}</letter>
          <letter v-else class="incorrect">{{char}}</letter>
      </span>
      </span>

      <!-- <letter v-for="(char, charIndex) in word" :key="charIndex">{{char}}</letter> -->
    </div>
    <p>{{result}}</p>
  </div>
    
</template>

<script>
export default {
  name: 'HelloWorld',
  data () {
    return {
      text: ["toto", "je", "text", "ktery", "bude", "psan", "na", "klavesnici"],
      currentText: '',
      writtenWords: [],
      userInput: '',
      currentWord: 0,
      currentPosition: 0,
      startTime: null,
      result: ""
    }
  },
  updated() {
      this.setCursor();
  },
  mounted() {
    this.setCursor()
    window.addEventListener('keydown', this.handleKeydown);
  },
  beforeUnmount() {  
    window.removeEventListener('keydown', this.handleKeydown);
  },
  computed: {
    words() {
      return "ahoj";
    }
  },
  methods: {
    handleKeydown(event) {
      // Nastavení počátečního času
      if (this.startTime === null) {
        this.startTime = new Date();
      }

      const key = event.key;
      if (/^[a-zA-Z]$/.test(event.key)) {
        if (this.writtenWords[this.currentWord] === undefined) {
          this.writtenWords[this.currentWord] = "";
        }
        this.writtenWords[this.currentWord] += key;
        //this.currentText += key;
      }
      if(key === ' ') {
        this.currentWord++;
        if (this.writtenWords[this.currentWord] === undefined) {
          this.writtenWords[this.currentWord] = "";
        }
      }
      if(key === 'Backspace') {
        if(this.writtenWords[this.currentWord] === '' && this.currentWord > 0) {
          this.currentWord--;
          
        }
        this.writtenWords[this.currentWord] = this.writtenWords[this.currentWord].slice(0, -1);
      }
      console.log(this.writtenWords);
      this.$forceUpdate();
      this.setCursor();

      //Pokud je stejně elemetů ve writtenWords jako v text a poslední elementy obou polí jsou stejné, tak se vypočítá doba trvání
      if (this.writtenWords.length === this.text.length && this.writtenWords[this.writtenWords.length - 1] === this.text[this.text.length - 1]) {
        const endTime = new Date();
        const timeDiff = endTime - this.startTime; //in ms
        // strip the ms
        const seconds = timeDiff

        //Correct words calculation
        let correctWords = 0;
        for (let i = 0; i < this.text.length; i++) {
          if (this.text[i] === this.writtenWords[i]) {
            correctWords++;
          }
        }
        console.log(seconds + " seconds");
        console.log(Math.floor(correctWords / seconds * 60000) + " WPM")
        this.result = Math.floor(correctWords / seconds * 60000) + " WPM Počet správných slov: " + correctWords + "/" + this.text.length + "";
      }
    },
    checkActualWord() {
      print(1)
    },
    setCursor() {
      const allElementsLetter = document.querySelectorAll('letter'); // Vybere všechny elementy
      allElementsLetter.forEach(element => {
        element.style.borderLeft = '';
        element.style.borderRight = '';
      });

      const allElements = document.querySelectorAll('.not-written'); // Vybere všechny elementy

      if (allElements.length > 0) {
        allElements[0].style.borderLeft = 'solid thin yellow';
      }
      else {
        const allElementsC = document.querySelectorAll('.current-word'); // Vybere všechny elementy
        allElementsC[allElementsC.length - 1].style.borderRight = 'solid thin yellow';
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

letter {
  color: #646669;
}
.correct { color: #d1d0c5; }
.current { background-color: yellow; }
.incorrect { color: #ca4754; }
.word {
  display: inline-block;
  margin-left: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue